import { useState } from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

export interface EmailInputProps {
  onSubmit: (email: string) => void
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const EmailInput = ({ onSubmit }: EmailInputProps) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [touched, setTouched] = useState(false)

  const validate = (value: string): boolean => {
    if (!value.trim()) {
      setError(null)
      return false
    }
    if (!EMAIL_REGEX.test(value.trim())) {
      setError('Invalid email format')
      return false
    }
    setError(null)
    return true
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setEmail(value)
    if (touched) {
      validate(value)
    }
  }

  const handleBlur = () => {
    setTouched(true)
    validate(email)
  }

  const isValid = EMAIL_REGEX.test(email.trim())

  const handleSubmit = () => {
    setTouched(true)
    if (validate(email)) {
      onSubmit(email.trim())
      setEmail('')
      setError(null)
      setTouched(false)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <TextField
        label='Email'
        placeholder='Enter an email address...'
        type='email'
        value={email}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        fullWidth
        error={touched && !!error}
        helperText={touched ? error : undefined}
      />
      <Button
        variant='contained'
        onClick={handleSubmit}
        disabled={!isValid}
        sx={{ alignSelf: 'flex-start' }}
      >
        Send Invite
      </Button>
    </Box>
  )
}

export default EmailInput
